import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from '@mui/material'
import { useState } from 'react'
import { metodoPrograma } from '../../../components/api'
import FormattedTextEditor from '../../../components/FormattedTextEditor/FormattedTextEditor'

const ModalEdicaoMedicamento = ({ data: { medicamento }, close }) => {
  const [nmMedicamento, setNmMedicamento] = useState(medicamento.nmMedicamento)
  const [dsInformacoes, setDsInformacoes] = useState(medicamento.dsInformacoes)
  const [dsPosologia, setDsPosologia] = useState(medicamento.dsPosologia)
  const [salvando, setSalvando] = useState(false)
  const [erroNome, setErroNome] = useState('')

  const salvar = async () => {
    if (!nmMedicamento?.trim()) {
      setErroNome('Informe o nome do medicamento.')
      return
    }

    setSalvando(true)
    const res = await metodoPrograma(
      'alteraMedicamentoReceituario',
      {
        idMedicamento: medicamento.idMedicamento,
        nmMedicamento: nmMedicamento.trim(),
        dsInformacoes,
        dsPosologia,
      },
      'CtrlReceitaAvulsa',
    )
    setSalvando(false)

    if (res?.status) {
      close({
        idMedicamento: medicamento.idMedicamento,
        nmMedicamento: nmMedicamento.trim(),
        dsInformacoes,
        dsPosologia,
      })
    }
  }

  return (
    <Dialog maxWidth="md" fullWidth open onClose={() => close(false)}>
      <DialogTitle>Editar medicamento</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          fullWidth
          label="Nome"
          margin="dense"
          value={nmMedicamento}
          onChange={(event) => {
            setNmMedicamento(event.target.value)
            setErroNome('')
          }}
          error={!!erroNome}
          helperText={erroNome}
        />
        <FormattedTextEditor
          label="Composição"
          value={dsInformacoes}
          onChange={setDsInformacoes}
          minHeight={240}
        />
        <FormattedTextEditor
          label="Posologia"
          value={dsPosologia}
          onChange={setDsPosologia}
          minHeight={180}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={() => close(false)} disabled={salvando}>
          Cancelar
        </Button>
        <Button onClick={salvar} variant="contained" disabled={salvando}>
          Salvar
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ModalEdicaoMedicamento
